__turbopack_context__.v({
  "rating-skeleton": "ratings-with-enrollments-module-scss-module__xGC4xW__rating-skeleton",
  "ratings-with-enrollments": "ratings-with-enrollments-module-scss-module__xGC4xW__ratings-with-enrollments",
});
